import { Input, InputNumber, DatePicker, Form } from 'antd'
import { CommentFormItem } from '../CommentFormItem'
import React from 'react'
import SharePointUploader from 'components/SharePointUploader'
import { SharePointParentFolder } from 'shared'
import CIMSSelect from 'components/CIMSSelect'
import { useSubmittalTrackerContext } from '../../../../../../SubmittalTrackerContext'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { RevisionActionsProps } from './types'

export const RevisionActions: React.FC<RevisionActionsProps> = ({
  sharePointFolderName,
}) => {
  const { typeOptions, subtypeOptions } =
    useSubmittalTrackerContext().selectOptions
  const help = HelpMessage.CAS.SubmittalTracker
  return (
    <>
      <Form.Item hidden name="action" initialValue="revise">
        <Input />
      </Form.Item>
      <CIMSFormItem
        name="packageNumber"
        label="Package Number"
        requiredMessage="Please enter a package number"
        disabled={{
          disabled: true,
          reason: {
            why: 'disabled',
            message: 'Cannot be edited in this dialog',
          },
        }}
        help={help.PackageNumber}
      >
        <Input disabled />
      </CIMSFormItem>
      <CIMSFormItem
        name="packageName"
        label="Package Name"
        requiredMessage="Please enter a package name"
        disabled={{
          disabled: true,
          reason: {
            why: 'disabled',
            message: 'Cannot be edited in this dialog',
          },
        }}
        help={help.PackageName}
      >
        <Input disabled />
      </CIMSFormItem>
      <CIMSFormItem
        name="type"
        label="Type"
        requiredMessage="Please select a type"
        help={help.Type}
      >
        <CIMSSelect options={typeOptions} />
      </CIMSFormItem>
      <CIMSFormItem name="subtype" label="Subtype" help={help.Subtype}>
        <CIMSSelect options={subtypeOptions} />
      </CIMSFormItem>
      <CIMSFormItem
        name="quantity"
        label="Quantity"
        help={help.Quantity}
        requiredMessage="Please enter a quantity"
      >
        <InputNumber />
      </CIMSFormItem>
      <CIMSFormItem
        name="units"
        label="Units"
        requiredMessage="Please enter units"
        help={help.Units}
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="requestedReviewDate"
        label="Requested Review Date"
        requiredMessage="Please enter a requested review date"
        help={help.RequestedReviewDate}
      >
        <DatePicker />
      </CIMSFormItem>
      {/* this is here on purpose to get the correct spacing */}
      <Form.Item>
        <SharePointUploader
          parent={SharePointParentFolder.ConstructionAdminSubmittals}
          folder={sharePointFolderName}
          sharePointResourceList={false}
        />
      </Form.Item>
      <CommentFormItem required={{ action: 'revision' }} />
    </>
  )
}
